module.exports = __webpack_public_path__ + "static/10-3fa7d800524aa9f5f915e663c0374a2a.png";